import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
  selector: "ab-add-deploys-callout",
  templateUrl: "./add-deploys-callout.component.html",
})
export class AddDeploysCalloutComponent {
  @Input() public project: any;
  @Output() public dismiss = new EventEmitter<void>();

  public dismissCallout() {
    this.dismiss.emit();
  }
}
